import { React, useState, useEffect, Select, Toast, CustomTable, CustomSwitch, Icon, useUser } from "../../utils/commonImports";
import { Modal, ModalHeader, ModalBody, ModalFooter, Table as TableReactsrap, Button } from "reactstrap";
import { customStyleMd } from "../../utils/common";
import { _api } from '../../auth/Api';
import { getPageRights } from "../../utils/accessPages";

const assinC = [
  { title: "Role Id", dataIndex: "roleId" },
  { title: "Role Name", dataIndex: "roleName" },
  {
    title: "Status", dataIndex: "roleIsActive",
    render: (roleIsActive) => (
      <span className={`badge ${roleIsActive ? 'bg-success' : 'bg-danger'}`}>
        {roleIsActive ? 'Active' : 'Inactive'}
      </span>
    )
  },
];

const AssignRole = () => {
  const [pages, setPages] = useState([]);
  const [rolesDrp, setRolesDrp] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);

  const [assignRoles, setAssignRoles] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [data, setData] = useState({});
  const [permissions, setPermissions] = useState([]);

  const [detailModal, setDetailModal] = useState({ isOpen: false, data: null });

  const { loggedInUser } = useUser();
  const userPages = loggedInUser?.roles?.[0]?.pages || [];

  const rights = getPageRights(userPages, 10);

  const launchDetailModal = (record) => {
    setDetailModal({ isOpen: true, data: record });
  };
  const closeDetailModal = () => {
    setDetailModal({ isOpen: false, data: null });
  };

  useEffect(() => {
    _getPages();
    // _getRoles();
    _getRoleAssign();
  }, []);

  const _getRoles = async () => {
    try {
      await _api("GET", "Roles/GetAllActiveRoles", null, function (res) {
        if (res.isSuccess) {
          const List = res.data.map((role) => ({
            value: role.id,
            label: role.roleName,
          }));
          setRolesDrp(List);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const _getPages = async () => {
    try {
      await _api("GET", "Pages/GetAllActivePages", null, (res) => {
        if (res.isSuccess) {
          const PageList = res?.data.map((page) => ({
            pageId: page.id,
            pageName: page.pageName,
            view: false,
            add: false,
            edit: false,
            delete: false,
          }));
          setPages(PageList);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const _getRoleAssign = async () => {
    try {
      await _api("GET", "PortalUserRoleDetail/GetAllPortalUserRoleDetails", null, function (res) {
        if (res.isSuccess) {
          setAssignRoles(res.data)
        }
      });
    } catch (error) {
      console.log(error);
    }
  };
  const launchModal = (d, type) => {
    if (type) {
      _getRoles();
    }
    setModalShow(type);
    setData(d);

    if (!type) {
      // Closing the modal
      setSelectedRole(null);
      setPermissions([]);
      return;
    }

    if (d?.roleId) {
      // Edit case
      const selected = rolesDrp.find((r) => r.value === d.roleId);
      setSelectedRole(selected);

      const updatedPermissions = pages
        .filter((page) => page.pageName.toLowerCase() !== "dashboard") // 👈 dashboard skip
        .map((page) => {
          const matched = d.pages?.find((p) => p.pageId === page.pageId);
          return {
            roleDetailId: matched?.roleDetailId || 0,
            pageId: page.pageId,
            pageName: page.pageName,
            view: matched?.view || false,
            add: matched?.add || false,
            edit: matched?.edit || false,
            delete: matched?.delete || false,
          };
        });

      // 👇 Add dashboard manually with full access
      updatedPermissions.push({
        pageId: 1, // replace with actual dashboard id
        pageName: "Dashboard",
        view: true,
        add: true,
        edit: true,
        delete: true,
      });

      setPermissions(updatedPermissions);
    } else {
      // Add case
      const newPermissions = pages
        .filter((menu) => menu.pageName.toLowerCase() !== "dashboard") // 👈 dashboard skip
        .map((menu) => ({
          pageId: menu.pageId,
          pageName: menu.pageName,
          view: false,
          add: false,
          edit: false,
          delete: false,
        }));

      // 👇 Add dashboard manually with full access
      newPermissions.unshift({
        pageId: 1, // replace with actual dashboard id
        pageName: "Dashboard",
        view: true,
        add: true,
        edit: true,
        delete: true,
      });

      setPermissions(newPermissions);
    }
  };

  const handleToggle = (pageId, type) => {
    setPermissions((prev) =>
      prev.map((perm) =>
        perm.pageId === pageId ? { ...perm, [type]: !perm[type] } : perm
      )
    );
  };

  const _saveRoleAssign = async () => {
    if (!selectedRole?.value) {
      Toast.fire({ icon: "error", title: "Please select role to assign pages" });
      return;
    }
    const isUpdate = permissions.some((page) => page.roleDetailId > 0);
    const url = isUpdate ? "PortalUserRoleDetail/UpdatePortalUserRoleDetail" : "PortalUserRoleDetail/AddPortalUserRoleDetail";
    const payload = permissions.map((page) => {
      const basePayload = {
        view: !!page.view,
        add: !!page.add,
        edit: !!page.edit,
        delete: !!page.delete,
        roleId: selectedRole.value,
        pageId: page.pageId,
      };
      if (isUpdate) {
        basePayload.roleDetailId = page.roleDetailId > 0 ? page.roleDetailId : 0;
      }
      return basePayload;
    });
    // debugger
    // console.log("payload",payload)
    // return
    await _api("POST", url, payload, function (res) {
      if (res.isSuccess) {
        _getRoleAssign();
        launchModal({}, false);
        Toast.fire({ icon: "success", title: res.message });
      } else if (res.isError) {
        Toast.fire({ icon: "error", title: res.message });
      }
    });
  };

  return (
    <>
      {rights && rights.add && (
        <div className="d-flex justify-content-end" style={{ marginBottom: "10px" }}>
          <button
            onClick={() => launchModal({}, true)}
            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
            style={{ lineHeight: '1.2' }}
          >
            Add / Manage Role <Icon icon="mdi:plus-circle-outline" className="text-md" />
          </button>
        </div>
      )}
      <CustomTable
        columns={assinC}
        dataSource={assignRoles}
        options={{
          //  pageKey:"Roles Management",
          pageKey: 10,
          withActions: true,
          showEdit: true,
          showDelete: false,
          showView: true,
          loading: false,
          rowKey: "roleId",
          bordered: true,
          size: "small",
          emptyText: "No Assign Roles found",
        }}
        onEdit={(rowData) => launchModal(rowData, true)}
        onDelete={(d) => console.log(d?.id)}
        onView={(d) => launchDetailModal(d)}
      />

      <Modal isOpen={modalShow} toggle={() => launchModal({}, false)} size="xl" centered>
        <ModalHeader toggle={() => launchModal({}, false)}>
          <span className="text-lg m-auto fw-500"> {data && Object.keys(data).length > 0 ? "Update " : "Add "} Role Access and Page Permissions</span>
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-6">
              <Select
                options={rolesDrp}
                isClearable
                placeholder="Select Role"
                value={selectedRole}
                onChange={(r) => setSelectedRole(r)}
                styles={customStyleMd}
              />
            </div>
            <div className="col-md-6"></div>
          </div>
          <div style={{ border: "1px solid #ccc", borderRadius: "7px", padding: "10px", maxHeight: "400px", overflowY: "scroll", marginTop: "10px", }}>
            <TableReactsrap size="md" className="table-flush">
              <thead>
                <tr>
                  <th className="text-sm">Page Name</th>
                  <th className="text-sm">View</th>
                  <th className="text-sm">Add</th>
                  <th className="text-sm">Edit</th>
                  <th className="text-sm">Delete</th>
                </tr>
              </thead>
              <tbody>
                {permissions.length > 0 ? (
                  permissions
                    .filter((perm) => perm.pageName.toLowerCase() !== "dashboard") // 👈 dashboard UI me skip
                    .map((perm) => (
                      <tr key={perm.pageId}>
                        <td className="text-sm">{perm.pageName}</td>
                        <td><CustomSwitch id={`view-${perm.pageId}`} checked={perm.view} onChange={() => handleToggle(perm.pageId, "view")} /></td>
                        <td><CustomSwitch id={`add-${perm.pageId}`} checked={perm.add} onChange={() => handleToggle(perm.pageId, "add")} /></td>
                        <td><CustomSwitch id={`edit-${perm.pageId}`} checked={perm.edit} onChange={() => handleToggle(perm.pageId, "edit")} /></td>
                        <td><CustomSwitch id={`delete-${perm.pageId}`} checked={perm.delete} onChange={() => handleToggle(perm.pageId, "delete")} /></td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="5">No pages available</td>
                  </tr>
                )}
              </tbody>
            </TableReactsrap>
          </div>
        </ModalBody>
        <ModalFooter>
          {/* <Button className="btn btn-dark btn-sm" type="button" onClick={() => launchModal({}, false)}> Close </Button> */}
          <Button className="btn btn-changan btn-sm" type="button" onClick={_saveRoleAssign}> {data && Object.keys(data).length > 0 ? "Update " : "Save "} </Button>
        </ModalFooter>
      </Modal>
      <Modal centered isOpen={detailModal.isOpen} size="xl" aria-labelledby="contained-modal-title-vcenter" >
        <ModalHeader className="" toggle={closeDetailModal}>
          <h6 className="text-lg m-auto"><span className="text-primary">{detailModal.data ? detailModal.data.roleName : ''}</span> Role Details</h6>
        </ModalHeader>
        <ModalBody>
          {detailModal?.data && (
            <div className="container" style={{ maxHeight: '450px', overflowY: 'scroll', }}>
              <div className="mt-2">
                <div className="row">
                  <table className="permissions-table table">
                    <thead>
                      <tr>
                        <th className="text-sm text-secondary-light">Page Name <span className="badge bg-primary"> {detailModal.data ? detailModal.data.pages.length : "0"} </span></th>
                        <th className="text-sm text-secondary-light">Can View</th>
                        <th className="text-sm text-secondary-light">Can Add</th>
                        <th className="text-sm text-secondary-light">Can Edit</th>
                        <th className="text-sm text-secondary-light">Can Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {detailModal.data.pages?.map((menu, key) => (
                        <tr key={key}>
                          <td className="text-sm text-secondary-light">{menu.pageName}</td>
                          <td>
                            <span className={`badge ${menu.view ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>
                              {menu.view ? 'Yes' : 'No'}
                            </span>
                          </td>
                          <td>
                            <span className={`badge ${menu.add ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>
                              {menu.add ? 'Yes' : 'No'}
                            </span>
                          </td>
                          <td>
                            <span className={`badge ${menu.edit ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>
                              {menu.edit ? 'Yes' : 'No'}
                            </span>
                          </td>
                          <td>
                            <span className={`badge ${menu.delete ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>
                              {menu.delete ? 'Yes' : 'No'}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button className="btn btn-dark btn-sm" onClick={closeDetailModal}> Close </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AssignRole;